import axios from 'axios';
const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8787';
/**
 * 上传文件到 Google Drive
 */
export async function uploadToGoogleDrive(request) {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/upload`, request, {
            timeout: 60000 // 60秒超时
        });
        return response.data;
    }
    catch (error) {
        console.error('Upload error:', error);
        return {
            success: false,
            error: error.response?.data?.error || error.message || '上传失败'
        };
    }
}
/**
 * 检查后端服务健康状态
 */
export async function checkHealth() {
    try {
        const response = await axios.get(`${API_BASE_URL}/health`, {
            timeout: 5000
        });
        return response.data.success === true;
    }
    catch (error) {
        return false;
    }
}
